import { ButtonProps } from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { format, parseISO } from "date-fns";
import { useMemo } from "react";
import { CountUp } from "../../../components/CountUp";
import { Dialog } from "../../../components/Dialog";
import { Enrichment } from "../../../types/enrichment";
import { useStyles } from "../styles";

type DetailsEnrichmentProps = {
  data: Enrichment | null;
  open: boolean;
  onClose: () => void;
};

export function DetailsEnrichment({
  data,
  open,
  onClose,
}: DetailsEnrichmentProps) {
  const styles = useStyles();
  const actions: ButtonProps[] = useMemo(() => {
    return [
      {
        children: "Fechar",
        onClick: onClose,
      },
    ];
  }, [onClose]);

  const translateRule = useMemo(() => {
    return {
      update: "Substituir valores existentes",
      complete: "Completar campos em branco",
    };
  }, []);

  return (
    <Dialog
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      title={data?.nome_prospeccao}
      open={open}
      actions={actions}
    >
      <div className={styles.rootContent}>
        <Typography color="primary" marginBottom={2}>
          Detalhes
        </Typography>
        <Typography variant="body2" marginBottom={2}>
          ID: {data?.id_base}
        </Typography>
        <Typography variant="body2" marginBottom={2}>
          ID Audiência: {data?.id_prospeccao}
        </Typography>
        <Typography variant="body2" marginBottom={2}>
          Audiência: {data?.nome_prospeccao}
        </Typography>
        <Typography variant="body2" marginBottom={2}>
          Status do enriquecimento:{" "}
          {Boolean(data?.processado) ? "Concluído" : "Processando"}
        </Typography>

        <div className={styles.textCoast}>
          <Typography variant="body2" marginRight={1}>
            Crédito consumidos:
          </Typography>
          <CountUp
            variant="body2"
            start={0}
            end={Number(data?.quantity_enrichment)}
            marginBottom={2}
          />
        </div>
        <Typography variant="body2" marginBottom={2}>
          {/*@ts-ignore*/}
          Regra: {translateRule[data?.rule_enrichment]}
        </Typography>
        <Typography variant="body2" marginBottom={2}>
          Nome responsàvel: {data?.user_empresa}
        </Typography>
        {data?.data_insert && (
          <Typography variant="body2" marginBottom={2}>
            Data de solicitação:{" "}
            {format(
              parseISO(data?.data_insert?.replace("Z", "")),
              "dd/MM/yyyy HH:mm"
            )}
          </Typography>
        )}
      </div>
    </Dialog>
  );
}
